import { PATTERNS } from "constants/appConstant";
import * as Yup from "yup";

export const YupValidations = {
  required: Yup.string().required("validate.required"),
  requiredString: Yup.string()
    .trim()
    .required("validate.required")
    .max(255, "validate.max_length_255")
    .matches(PATTERNS.XSS_PATTERN, {
      message: "validate.noxss",
    }),
  password: Yup.string()
    .required("validate.required")
    .matches(PATTERNS.PASSWORD_POLICY, {
      message: "validate.invalid_password_policy",
    }),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "validate.confirmPassword.mismatch")
    .required("validate.required"),
  email: Yup.string()
    .trim()
    .max(255, "validate.max_length_255")
    .required("validate.required")
    .email("validate.email.invalid"),
  // .matches(PATTERNS.EMAIL_PATTERN, {
  //   message: "validate.email.invalid",
  // }),
  userGroupName: Yup.string()
    .required("validate.required")
    .max(64, "validate.max_length_64"),
  noXSS: Yup.string().matches(PATTERNS.XSS_PATTERN, {
    message: "validate.noxss",
  }),
  username: Yup.string()
    .trim()
    .required("validate.required")
    .min(6, "validate.min_length_6")
    .max(255, "validate.max_length_255")
    .matches(PATTERNS.USERNAME, {
      message: "validate.noxss",
    }),
  phoneNumber: Yup.string()
    .trim()
    .required("validate.required")
    .matches(PATTERNS.PHONE_NUMBER, {
      message: "validate.phoneNumber.invalid",
    })
    .min(6, "validate.min_length_6")
    .max(45, "validate.max_length_45"),
  name: Yup.string()
    .trim()
    .required("validate.required")
    .matches(PATTERNS.XSS_PATTERN, "validate.noxss")
    .max(255, "validate.max_length_255"),
};
